import { createContext } from 'react';

const tareasXprocedimientoContext = createContext();

export default tareasXprocedimientoContext;